import { withApollo } from "react-apollo";
import React from "react";
class MessageConfigurationView extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <h1 className="heading m-b-25">Message Configuration Details</h1>
        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      Description<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext"
                      defaultValue={this.props.message.description}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </div>
    );
  }
}

export default MessageConfigurationView;
